import { render, staticRenderFns } from "./ExteriorAttentionDetailTop.vue?vue&type=template&id=be3640a2&scoped=true&"
import script from "./ExteriorAttentionDetailTop.vue?vue&type=script&lang=js&"
export * from "./ExteriorAttentionDetailTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3640a2",
  null
  
)

export default component.exports